// import required libraries
import $ from 'jquery';

// Import Pages
import accessibility from './actions/accessibility';
import PageFrontPage from './pages/PageFrontPage';
import renderTabsBlock from './actions/renderTabsBlock';
import lenisSmoothScrolling from './components/lenisSmoothScrolling';
import heroBlock from './components/heroBlock';
import fadeUp from './components/fadeUp';

// call functions
lenisSmoothScrolling();
fadeUp();
heroBlock();
accessibility();
PageFrontPage($);
renderTabsBlock($);
